module.exports = __webpack_public_path__ + "media/images/icons/link-e725e730a978633ba3814d2c7734fa4d.svg";